import Container_ScotchDoubleHorizontalAreaComponent from '../components/Container/viewer/skinComps/ScotchDoubleHorizontalArea/ScotchDoubleHorizontalArea.skin';


const Container_ScotchDoubleHorizontalArea = {
  component: Container_ScotchDoubleHorizontalAreaComponent
};


export const components = {
  ['Container_ScotchDoubleHorizontalArea']: Container_ScotchDoubleHorizontalArea
};

